import { ChangeEvent, InputHTMLAttributes } from "react";

import { IConsolePageInputsProps } from "pages/[tenant]/console/types";
import { removeSpacesAndAccentsFromString } from "pages/[tenant]/console/utils/normalizeString";

import { ConsolePageInputContainer } from "./styles";

export type IConsolePageInputExtendedProps =
  InputHTMLAttributes<HTMLInputElement> & IConsolePageInputsProps;

export interface IConsolePageInputProps extends IConsolePageInputExtendedProps {
  useCustomId?: boolean;
  showCharactersLimit?: boolean;
  showRightIcon?: boolean;
  RightIcon?: ({ ...props }) => JSX.Element;
}

export const ConsolePageInput = ({
  label,
  isInvalid,
  required,
  useCustomId,
  showCharactersLimit = false,
  showRightIcon = false,
  RightIcon,
  ...props
}: IConsolePageInputProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (props?.onChange) props.onChange(event);
  };

  const customId = useCustomId
    ? removeSpacesAndAccentsFromString(label?.toString())
    : props?.id || "";

  const charactersLength = props?.value?.toString()?.length ?? 0;
  const charactersLimit = props?.maxLength;

  return (
    <ConsolePageInputContainer
      shouldMoveFloatingLabel={!!props?.value}
      isInvalid={isInvalid}
      id={`console-input-container-${props?.id}`}
    >
      <label htmlFor={props?.id}>
        {label}
        {required && <span className="required-flag">*</span>}
      </label>

      <input
        onChange={handleChange}
        value={props?.value}
        required={required}
        autoComplete="off"
        data-testid="console-page-input"
        id={customId}
        {...props}
      />

      {!isInvalid && showRightIcon && RightIcon?.name && (
        <RightIcon className="console-input-container-right-icon" />
      )}

      {showCharactersLimit && (
        <span className="characters-limit">
          {charactersLength}/{charactersLimit}
        </span>
      )}
    </ConsolePageInputContainer>
  );
};
